export default __webpack_public_path__ + "static/media/logo-segfy-light.1c6a2d5b.svg";